import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { useRatingNpsStyles } from "./RatingNps.style";

interface IProps {
	ratingValue: number | null;
	setRatingValue: (value: number) => void;
}

const RatingNps = ({ ratingValue, setRatingValue }: IProps) => {
	const { classes } = useRatingNpsStyles();

	return (
		<FormControl>
			<RadioGroup
				row
				name="radio-buttons-group"
				className={classes.radioWrapper}
				value={ratingValue}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
					setRatingValue(Number(event.target.value))
				}
			>
				{Array.from({ length: 10 }, (_, i) => i).map(i => (
					<FormControlLabel
						key={i + 1}
						value={i + 1}
						label={i + 1}
						labelPlacement="top"
						control={<Radio />}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
};

export default RatingNps;
